module.exports = __webpack_public_path__ + "static/media/todo.d8b48833.png";